export const SLIDE_ANIMATION_TIMEOUT = 100;
